import { apiClient } from "../apiClient";
import { API_ENDPOINTS } from "@repo/constants";
import { AxiosError } from "axios";
import {
  GetHotelsListRequest,
  GetHotelsListResponse,
  InsertHotelRequest,
  InsertHotelResponse,
  UpdateHotelRequest,
  UpdateHotelsResponse,
} from "@repo/types";

export const getOneDeskHotels = async (
  payload: GetHotelsListRequest,
): Promise<GetHotelsListResponse> => {
  try {
    const response = await apiClient.post<GetHotelsListResponse>(
      API_ENDPOINTS.getHotelList,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error fetching hotels:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return {
      Success: false,
      Message: apiMessage,
      StatusCode: 500,
      Data: [],
    };
  }
};

export const insertHotel = async (
  payload: Partial<InsertHotelRequest>,
): Promise<InsertHotelResponse> => {
  try {
    console.log("Hotel Register payload", payload);
    const response = await apiClient.post<InsertHotelResponse>(
      API_ENDPOINTS.insertHotel,
      payload,
      {
        skipEncryption: true,
      } as any,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error inserting hotel:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};

export const updateHotel = async (
  payload: Partial<UpdateHotelRequest>,
): Promise<UpdateHotelsResponse> => {
  try {
    const response = await apiClient.put<UpdateHotelsResponse>(
      API_ENDPOINTS.updateHotelList,
      payload,
    );
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error updating hotel:", error);
    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";
    return { Success: false, Message: apiMessage, StatusCode: 500 };
  }
};
